/**
 * APX — segunda capa de intermediación de Publicis (acuerdo PMX 10% + APX 9%). Capa PARALELA
 * aditiva sobre el BRUTO, molde idéntico al take de FASE 6 (ver ARQUITECTURA 7.18 / 9.32).
 *
 * Disparador por venta: `sales.apx_id` / `sales_contratos.apx_id`. Si está poblado, la venta lleva
 * APX y el % sale de `intermediarios[apx_id].comision` (resolución por ID, regla 10.7; hoy el
 * intermediario "PUBLICIS | APX" id 126 con comision=9). NULL → 0 (sin APX).
 *
 * Devuelve el monto APX en la MISMA moneda que `opp.importe` en el call site (a diferencia del
 * take, que vivía en USD y necesitaba conversión): como es `importe × %`, queda en local cuando
 * el caller pasa la venta en local (oppEnLocal) y en USD nativo cuando la pasa cruda. Por eso el
 * caller lo suma directo al `takeLocal`/`takeUsd` que ya pasa a los motores de base.
 *
 * Capa AISLADA (10.48): NO toca `calcularImporteNetoIntermediario` (agencia/PMX intactos).
 *
 * @param {Object} opp            venta (con apx_id e importe en la moneda del call site)
 * @param {Array|Object} intermediarios  array u objeto-mapa de intermediarios (país-scopeado)
 * @returns {number} monto APX en la moneda de opp.importe (0 si no hay apx_id)
 */
export const getApxMonto = (opp, intermediarios) => {
  if (opp?.apx_id == null) return 0;
  const apxId = parseInt(opp.apx_id, 10);
  if (isNaN(apxId)) return 0;
  const arr = Array.isArray(intermediarios) ? intermediarios : Object.values(intermediarios || {});
  const inter = arr.find((i) => i.id === apxId);
  const pct = inter?.comision || 0;
  if (!pct) return 0;
  return ((parseFloat(opp.importe) || 0) * pct) / 100;
};
